export default __webpack_public_path__ + "static/media/on_screen_instruction.1751c8de.png";